module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "intake",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.phrase.id
  }, [_c('h1', {
    staticClass: "h1 mt0 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.phrase.headline))]), _vm._v(" "), (_vm.phrase.sub_headline) ? _c('p', {
    staticClass: "p small c-mid mb-"
  }, [_vm._v("\n      " + _vm._s(_vm.phrase.sub_headline) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bcba1f8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/TextCarousel.vue
// module id = 428
// module chunks = 0